import type { FC } from "react";

import { useLocatorTranslations } from "@locators/components/shared/hooks/useLocatorTranslations";
import classNames from "classnames";

import styles from "./StoreLocatorOpeningStatus.module.scss";

type StoreLocatorOpeningStatusProps = {
  shopOpeningStatus: "open" | "closed" | "open_soon";
  shopOpeningHours: string;
  isNewStoreCardEnabled?: boolean;
};

export const shopStatus = {
  open: "open",
  closed: "closed",
  open_soon: "open_soon",
} as const;

export const StoreLocatorOpeningStatus: FC<StoreLocatorOpeningStatusProps> = ({
  shopOpeningStatus,
  shopOpeningHours,
  isNewStoreCardEnabled,
}) => {
  const { __ } = useLocatorTranslations();

  return (
    <div className={styles.shopStatusWrapper} data-testid="attributeValuesV2">
      <div
        className={classNames(styles.shopOpeningStatus, styles[`${shopOpeningStatus}`], {
          [styles.locatorV2ShopOpeningStatus]: isNewStoreCardEnabled,
          [styles.locatorV2ShopOpeningStatusFont]: isNewStoreCardEnabled,
        })}
        data-testid="shopOpeningStatus"
      >
        {__(`store_locator.popup.shop_status.${shopOpeningStatus}`)}
      </div>
      <div
        className={classNames(styles.shopOpeningTimeStatus, {
          [styles.locatorV2ShopOpeningStatusFont]: isNewStoreCardEnabled,
        })}
        data-testid="shopOpeningTimeStatus"
      >
        {__(
          shopOpeningStatus === shopStatus.open
            ? "store_locator.popup.shop_status.closesAt"
            : "store_locator.popup.shop_status.opensAt"
        )}{" "}
        {shopOpeningHours}
      </div>
    </div>
  );
};
